var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { VisuallyHiddenTestIds } from './visuallyHidden.testids';
/**
 * `VisuallyHidden` is a utility component that styles its children to be visually hidden
 * while remaining accessible to screen readers.
 *
 * This is useful for creating accessible labels for elements that otherwise contain only images or icons.
 */
export var VisuallyHidden = function (_a) {
    var children = _a.children, style = _a.style, restProps = __rest(_a, ["children", "style"]);
    return (_jsx("div", __assign({ "data-testid": VisuallyHiddenTestIds.ROOT, style: __assign({ border: 0, clip: 'rect(0 0 0 0)', clipPath: 'inset(50%)', height: 1, margin: '0 -1px -1px 0', overflow: 'hidden', padding: 0, position: 'absolute', whiteSpace: 'nowrap', width: 1 }, style) }, restProps, { children: children })));
};
VisuallyHidden.displayName = 'VisuallyHidden';
//# sourceMappingURL=visuallyHidden.js.map